import { Routes } from '@angular/router';
import { AdmbiblioListComponent } from './admbiblio-list/admbiblio-list.component';
import { AdmbiblioFormComponent } from './admbiblio-form/admbiblio-form.component';
import { AdmbiblioBlockFormComponent } from './admbiblio-block-form/admbiblio-block-form.component';

export const ADMBIBLIO_ROUTES: Routes = [
    { path: 'list/:idtier3', component: AdmbiblioListComponent },
    { path: 'add/:idtier3', component: AdmbiblioFormComponent },
    { path: 'edit/:id', component: AdmbiblioFormComponent },
    { path: 'addAll/:idtier3', component: AdmbiblioBlockFormComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'list' }
];